module.exports = __webpack_public_path__ + "img/antt-act-img3.db53268f.png";